import React, { useState } from 'react'
import Icon from 'react-icons-kit'
import { edit2 } from 'react-icons-kit/feather'
import { useForm } from 'react-hook-form'
import User from "../../../utils/Requests/User"
import './style.scss'
import { toast } from 'react-toastify'
//import 'react-toastify/dist/ReactToastify.css'
////toast.configure({ autoClose: 2000 })

const NewPhone = ({ email, phone, handleRefetch }) => {
    const [phonedEdit, setPhonedEdit] = useState({ show: false, loading: false })
    const { handleSubmit, register, formState: { errors } } = useForm()
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    const onSubmit = async (data) => {
        setPhonedEdit({ ...phonedEdit, loading: true })
        let obj ={
            phone: data.phone
        }
        const response = await User.ResetPhone(email, obj, header)
        if (response.status) {
            toast.success(response.message)
        }
        setPhonedEdit({ show: false, loading: false })
        handleRefetch()
    }

    return (
        <div className="detailInformations" >
            <div className="card shadow mb-4" >
                <div className="card-header px-4 pt-3 pb-0">
                    <div className="d-flex justify-content-between">
                        <div><h5 className="mb-0">Reset Phone</h5></div>
                        <div className="ml-auto">
                            <button className="btn rounded-circle shadow"
                                onClick={() => setPhonedEdit({ ...phonedEdit, show: !phonedEdit.show })}
                            >
                                <Icon icon={edit2} size={20} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body p-4">
                    {
                        phonedEdit.show ? 
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {errors.phone ? <span className='text-danger mb-3'>{errors.phone.message}</span> : null}
                            <div className="form-group mb-4">
                                <input
                                    type="number"
                                    className="form-control shadow-none"
                                    placeholder="Enter phone number"
                                    name="phone"
                                    defaultValue={phone}
                                    {...register("phone",{ required: '*phone number can not be empty.' })}
                                />
                            </div>

                            <div className="text-end pt-3">
                                <button
                                    type="submit"
                                    className="btn shadow-none save-btn"
                                    disabled={phonedEdit.loading}
                                >
                                    {phonedEdit.loading ? 'Updation...' : 'Update'}
                                </button>
                            </div>
                        </form>
                        :
                        <p className="text-justify">{phone}</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default NewPhone;